(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8125],{

/***/ 26538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y8": function() { return /* binding */ Radio; },
  "Ee": function() { return /* binding */ RadioGroup; },
  "Wh": function() { return /* binding */ useRadioContext; }
});

// UNUSED EXPORTS: RadioContextProvider

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/radio/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/@wartek-id/react-utils/dist/index.esm.js
var index_esm = __webpack_require__(81725);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/radio/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Radio-module_radioGroup__2YzcN{display:flex}.Radio-module_radio__MetkD{outline:none;display:inline-flex;box-sizing:border-box;position:relative;cursor:pointer;font-size:22px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.Radio-module_radio__MetkD.Radio-module_start__1Oi3n{align-items:flex-start}.Radio-module_radio__MetkD.Radio-module_center__2H_ba{align-items:center}.Radio-module_radio__MetkD.Radio-module_end__PueND{align-items:flex-end}.Radio-module_radio__MetkD input{border:0;clip:rect(0,0,0,0);height:1px;width:1px;margin:-1px;padding:0;overflow:hidden;white-space:nowrap;position:absolute}input[type=radio]:focus+.Radio-module_radioCheck__2yWd0{box-shadow:0 0 0 2px var(--color-surface-default),0 0 0 4px var(--color-interactive-focused)}.Radio-module_radio__MetkD[aria-disabled=true]{cursor:not-allowed}.Radio-module_radio__MetkD[aria-disabled=true] input+.Radio-module_radioCheck__2yWd0{border-color:var(--color-border-disabled);background-color:var(--color-surface-disabled)}.Radio-module_radio__MetkD[aria-disabled=true] .Radio-module_radioLabel__2q6xf{color:var(--color-text-disabled)}.Radio-module_radio__MetkD[aria-disabled=true]:hover .Radio-module_radioCheck__2yWd0{box-shadow:none}.Radio-module_radio__MetkD:hover .Radio-module_radioCheck__2yWd0{border:1px solid var(--color-interactive-default)}.Radio-module_radio__MetkD:hover input:checked~.Radio-module_radioCheck__2yWd0{border:6px solid var(--color-action-hovered)}.Radio-module_radioCheck__2yWd0{display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid var(--color-border-default);width:20px;height:20px;transition:border .3s ease-in-out;background-color:var(--color-surface-default);box-sizing:border-box;border-radius:50%}.Radio-module_radioCheck__2yWd0:before{content:\"\"}.Radio-module_radio__MetkD .Radio-module_radioCheck__2yWd0:after{top:9px;left:9px;width:8px;height:8px;border-radius:50%;background:var(--color-surface-default)}.Radio-module_radio__MetkD input:checked~.Radio-module_radioCheck__2yWd0{border:6px solid var(--color-interactive-default);transition:all .3s ease-in-out}.Radio-module_radio__MetkD[aria-disabled=true] input:checked~.Radio-module_radioCheck__2yWd0{background-color:var(--color-surface-default);border:6px solid var(--color-border-subdued);transition:all .3s ease-in-out}.Radio-module_radioLabel__2q6xf{font-size:1rem;line-height:22px;color:var(--color-text-default);padding-left:8px}";
var styles = {"radioGroup":"Radio-module_radioGroup__2YzcN","radio":"Radio-module_radio__MetkD","start":"Radio-module_start__1Oi3n","center":"Radio-module_center__2H_ba","end":"Radio-module_end__PueND","radioCheck":"Radio-module_radioCheck__2yWd0","radioLabel":"Radio-module_radioLabel__2q6xf"};
styleInject(css_248z);

var _a;
var RadioContextProvider = (_a = (0,index_esm/* createContext */.kr)({
    name: 'RadioGroupContext',
    strict: false,
}), _a[0]), useRadioContext = _a[1];

var RadioGroup = function (props) {
    var value = props.value, name = props.name, children = props.children, onChange = props.onChange, className = props.className, _a = props.labelPosition, labelPosition = _a === void 0 ? 'start' : _a, radioGroupProps = __rest(props, ["value", "name", "children", "onChange", "className", "labelPosition"]);
    return (react.createElement(RadioContextProvider, { value: { value: value, name: name, onChange: onChange, labelPosition: labelPosition } },
        react.createElement("div", __assign({ className: clsx_m(styles.radioGroup, className), role: "radiogroup" }, radioGroupProps), children)));
};

var Radio = react.forwardRef(function (props, radioRef) {
    var value = props.value, disabled = props.disabled, name = props.name, checked = props.checked, children = props.children, className = props.className, labelPosition = props.labelPosition, radioProps = __rest(props, ["value", "disabled", "name", "checked", "children", "className", "labelPosition"]);
    var context = useRadioContext();
    var radioClassNames = clsx_m(styles.radio, styles[labelPosition || (context === null || context === void 0 ? void 0 : context.labelPosition) || 'start'], className);
    return (react.createElement("label", __assign({ className: radioClassNames, "aria-disabled": disabled }, radioProps),
        react.createElement("input", { name: (context === null || context === void 0 ? void 0 : context.name) || name, ref: radioRef, type: "radio", checked: checked, className: styles.radioInput, disabled: disabled, "aria-disabled": disabled, defaultChecked: (context === null || context === void 0 ? void 0 : context.value) === value, value: value, onChange: function (e) { return (context === null || context === void 0 ? void 0 : context.onChange) && context.onChange(e.target.value); } }),
        react.createElement("span", { className: styles.radioCheck, "aria-hidden": true }),
        react.createElement("span", { className: styles.radioLabel }, children)));
});




/***/ }),

/***/ 35630:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/daftar-topik",
      function () {
        return __webpack_require__(16041);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TopicList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(54204);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var icon_dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./node_modules/@wartek-id/sheet/dist/index.esm.js + 3 modules
var sheet_dist_index_esm = __webpack_require__(34088);
// EXTERNAL MODULE: ./node_modules/@wartek-id/radio/dist/index.esm.js + 1 modules
var radio_dist_index_esm = __webpack_require__(26538);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/TopicFilter.tsx




var STATE_FILTER = {
    recommendation: "Rekomendasi",
    newest: "Paling baru",
    oldest: "Paling lama",
    "almost-done": "Hampir selesai",
    "just-started": "Baru mulai",
    title: "Judul A-Z"
};
var TopicFilter = function(param) {
    var isOpen = param.isOpen, selected = param.selected, onClose = param.onClose, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* Sheet */.yo, {
        type: "modal",
        isOpen: isOpen,
        autoFocus: true,
        closeOnOverlayClick: true,
        position: "bottom",
        returnFocus: true,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetOverlay */.lu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* SheetContent */.ue, {
                className: "max-w-xl m-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* SheetTitle */.bC, {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-4",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                    children: "arrow_back"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 text-lg font-semibold",
                                children: "Urutkan topik berdasarkan"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetBody */.Fm, {
                        className: "p-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* RadioGroup */.Ee, {
                            name: "filter",
                            value: selected,
                            className: "flex-col",
                            onChange: onSelect,
                            children: Object.keys(STATE_FILTER).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                    value: key,
                                    className: "mb-2",
                                    children: STATE_FILTER[key]
                                }, key);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TopicFilter = (TopicFilter);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js + 1 modules
var shimmer_dist_index_esm = __webpack_require__(28058);
// EXTERNAL MODULE: ./node_modules/@wartek-id/badge/dist/index.esm.js + 1 modules
var badge_dist_index_esm = __webpack_require__(10418);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/helper.tsx + 1 modules
var helper = __webpack_require__(30469);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicCard.tsx










var TopicCard = function(param) {
    var topicId = param.topicId, name = param.name, totalModule = param.totalModule, description = param.description, href = param.href, image = param.image, _isFetchingProgress = param.isFetchingProgress, isFetchingProgress = _isFetchingProgress === void 0 ? false : _isFetchingProgress, _badge = param.badge, badge = _badge === void 0 ? undefined : _badge, _active = param.active, active = _active === void 0 ? true : _active;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "topic-card",
        className: (0,clsx_m/* default */.Z)("relative flex flex-col p-3 pl-4 last:mb-0 rounded overflow-hidden border", active ? "border-primary bg-blue-20" : "bg-white border-subdued"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: href,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                        "data-topik-id": topicId,
                                        onClick: function() {
                                            (0,googleAnalytics/* GATrackEvent */.l)({
                                                eventName: "learning_activity",
                                                eventParams: {
                                                    event_trigger: "topik_click_from_list",
                                                    action_type: "choose_topik",
                                                    meta: JSON.stringify({
                                                        topic_id: topicId
                                                    })
                                                },
                                                sendDefaultParams: true
                                            });
                                        },
                                        className: "overlay-link",
                                        href: href,
                                        as: "a",
                                        variant: "heading-sm",
                                        children: name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line-clamp-2 text-ellipsis",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                    variant: "body-sm",
                                    color: "subdued",
                                    children: description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                        as: "i",
                                        color: "default",
                                        style: {
                                            fontSize: "16px"
                                        },
                                        fontSize: "small",
                                        children: "library_books"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-2 leading-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.x, {
                                            as: "span",
                                            variant: "helper-bold",
                                            color: "subdued",
                                            children: [
                                                totalModule,
                                                " modul"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("relative flex-grow-0 flex-shrink-0 w-16 h-16 rounded overflow-hidden", (!image || !image.length) && "flex items-center justify-center bg-expressive-dark-blue"),
                        children: !!image && image.length >= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "object-cover object-center w-16 h-16",
                            src: (0,helper/* cacheImage */.qM)(image),
                            alt: name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                            as: "i",
                            color: "inverse",
                            className: "block ml-auto",
                            fontSize: "large",
                            title: "Topik",
                            children: "library_books"
                        })
                    })
                ]
            }),
            isFetchingProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                height: 16,
                width: 140,
                className: "rounded-lg mt-3",
                "aria-busy": isFetchingProgress ? "true" : "false",
                role: "alert"
            }),
            !isFetchingProgress && !!badge && !!badge.state && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                "data-testid": "badge",
                className: "mt-3",
                variant: badge === null || badge === void 0 ? void 0 : badge.type,
                children: badge === null || badge === void 0 ? void 0 : badge.text
            })
        ]
    });
};
/* harmony default export */ var Topic_TopicCard = (TopicCard);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicPlaceholder.tsx
var TopicPlaceholder = __webpack_require__(25034);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/GenericList.tsx
var GenericList = __webpack_require__(11145);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/TabbedNav.tsx
var TabbedNav = __webpack_require__(18046);
// EXTERNAL MODULE: ./hooks/useSafeRouter.ts
var useSafeRouter = __webpack_require__(28873);
// EXTERNAL MODULE: ./utils/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(212);
// EXTERNAL MODULE: ./utils/api.ts
var api = __webpack_require__(71529);
;// CONCATENATED MODULE: ./api/microlearning/useAPITopicList.ts


function useAPITopicList(params) {
    return (0,api/* useQueryApi */.Zy)("/microlearnings/topic/v1/list?sort=".concat(params.sort), {
        queryConfig: {
            enabled: !!params.sort
        },
        errorHandlerFn: function(status, path, error) {
            (0,api/* handleCommonErrors */.CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useSETrackEvent.ts + 2 modules
var useSETrackEvent = __webpack_require__(35917);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/TopicList.tsx
/* provided dependency */ var process = __webpack_require__(34155);



















var TopicListRevamp = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop, _currentId = param.currentId, currentId = _currentId === void 0 ? null : _currentId;
    var ref = (0,useSETrackEvent/* useSETrackerEvent */.L)(), SETrackTopicList = ref.SETrackTopicList, SETrackChooseOrder = ref.SETrackChooseOrder;
    var safeReplace = (0,useSafeRouter/* useSafeRouter */._)().safeReplace;
    var useFilter = (0,useLocalStorage/* useLocalStorage */._)("topic-sort-filter", "recommendation");
    var filterValue = useFilter[0] || "recommendation";
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isSheetOpen = ref1[0], setIsSheetOpen = ref1[1];
    var ref2 = useAPITopicList({
        sort: filterValue
    }), topicListData = ref2.data, topicListStatus = ref2.status;
    var STATE_FILTER = {
        recommendation: "Rekomendasi",
        newest: "Paling Baru",
        oldest: "Paling lama",
        "almost-done": "Hampir selesai",
        "just-started": "Baru mulai",
        title: "Judul A-Z"
    };
    var handleTracker = function(item) {
        SETrackTopicList({
            action_type: "choose_topik",
            action_filter: filterValue,
            topic_id: item.id
        });
    };
    var selectFilter = function(value) {
        useFilter[1](value);
        setIsSheetOpen(false);
        SETrackChooseOrder({
            action_type: "choose_order",
            action_filter: value
        });
    };
    var RenderTopicList = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(GenericList/* default */.Z, {
            data: (topicListData === null || topicListData === void 0 ? void 0 : topicListData.data) || [],
            dataState: topicListStatus,
            listKey: function(param) {
                var id = param.id;
                return id;
            },
            errorComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                title: "Data gagal dimuat",
                description: "Ada kesalahan pada sistem. Silakan coba beberapa saat lagi.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                    onClick: function() {
                        return window.location.reload();
                    },
                    children: "Muat Ulang"
                })
            }),
            emptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                title: "Konten belum tersedia",
                description: "Belum ada topik yang dapat dipelajari saat ini; silakan coba lagi nanti."
            }),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicPlaceholder/* default */.Z, {
                amount: 4
            }),
            renderItem: function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return handleTracker(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicCard, {
                        topicId: item.id,
                        isFetchingProgress: topicListStatus !== "success",
                        name: item.name,
                        certifiable: item.certifiable,
                        totalModule: item.totalModule,
                        description: item.description,
                        href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(item.id, "?filter=").concat(filterValue),
                        image: item.headerImage,
                        badge: (0,helper/* determineBadge */.Et)(item),
                        active: String(item.id) === currentId
                    })
                });
            },
            itemClassName: "mb-2"
        });
    };
    if (isDesktop) {
        if (!currentId) {
            var ref3;
            var firstTopic = topicListData === null || topicListData === void 0 ? void 0 : (ref3 = topicListData.data) === null || ref3 === void 0 ? void 0 : ref3[0];
            (firstTopic === null || firstTopic === void 0 ? void 0 : firstTopic.id) && safeReplace("/pelatihan-mandiri/topik/".concat(firstTopic === null || firstTopic === void 0 ? void 0 : firstTopic.id));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Pelatihan Mandiri | Daftar Topik"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[80px] px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                            variant: "display-sm",
                            className: "mb-4",
                            children: "Daftar Topik"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderTopicList, {})
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Pelatihan Mandiri | Daftar Topik"
                })
            }),
            !(0,helper/* shouldHideNav */.J8)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabbedNav/* default */.Z, {
                activeMenu: "topik"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-10",
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)((0,helper/* shouldHideNav */.J8)() ? "pt-3" : "pt-0") + " relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-3 bg-white sticky top-[90px] z-10 mb-12 drop-shadow-md",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.z, {
                                    color: "white",
                                    fullWidth: true,
                                    onClick: function() {
                                        return setIsSheetOpen(true);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                                    children: "sort"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Urutkan:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        className: "text-blue-60",
                                                        children: STATE_FILTER[filterValue] || STATE_FILTER["recommendation"]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TopicFilter, {
                                isOpen: isSheetOpen,
                                selected: filterValue,
                                onClose: function() {
                                    return setIsSheetOpen(false);
                                },
                                onSelect: function(value) {
                                    return selectFilter(value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 pb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderTopicList, {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TopicList = (TopicListRevamp);


/***/ }),

/***/ 25034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28058);




var TopicPlaceholder = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 1 : _amount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "alert",
        "aria-label": "alert",
        "aria-busy": "true",
        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Array(amount)).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative mb-3 last:mb-0 rounded-lg overflow-hidden shadow-card",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "p-4 bg-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                style: {
                                    width: "100%"
                                },
                                height: 18
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex -mx-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center px-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 36,
                                        height: 16
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center px-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 36,
                                        height: 16
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                style: {
                                    width: "100%"
                                },
                                height: 16
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-wrap items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[140px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 140,
                                        height: 16
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "ml-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_3__/* .Shimmer */ .q, {
                                        width: 88,
                                        height: 16
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicPlaceholder);


/***/ }),

/***/ 16041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var app_PelatihanMandiriPage_pages_TopicList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92629);
/* harmony import */ var app_PelatihanMandiriPage_components_PageHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42220);
/* harmony import */ var app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30469);
/* harmony import */ var utils_hooks_context_useScreenSizeContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65260);
/* harmony import */ var components_Layout_Desktop_DesktopLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72351);







var DaftarTopikPage = function() {
    var isDesktop = (0,utils_hooks_context_useScreenSizeContext__WEBPACK_IMPORTED_MODULE_5__/* .useScreenSizeContext */ .fl)().isDesktop;
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Desktop_DesktopLayout__WEBPACK_IMPORTED_MODULE_6__/* .DesktopLayout */ .S_, {
            submenu: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_PelatihanMandiriPage_pages_TopicList__WEBPACK_IMPORTED_MODULE_2__["default"], {
                isDesktop: isDesktop
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_PelatihanMandiriPage_pages_TopicList__WEBPACK_IMPORTED_MODULE_2__["default"], {});
};
DaftarTopikPage.layoutOpts = {
    hasHeader: !(0,app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_4__/* .shouldHideNav */ .J8)(),
    className: "text-default bg-gray-10",
    header: app_PelatihanMandiriPage_components_PageHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    enableDesktopLayout: true
};
/* harmony default export */ __webpack_exports__["default"] = (DaftarTopikPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,5370,2627,4088,1529,7882,8085,1383,9774,2888,179], function() { return __webpack_exec__(35630); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);